import Inputmask from "inputmask";
export default class Mascaras  {
    maskCpf = new Inputmask("999.999.999-99")
    maskData = new Inputmask("99/99/9999")
    maskTelefone = new Inputmask("\(99\)99999-9999")
    maskCep = new Inputmask("99.999-999")
    
    start = () => {
        this.maskCpf.mask(('input.mask-cpf'))
        this.maskData.mask($('input.mask-data'))
        this.maskTelefone.mask($('input.mask-telefone'))
        this.maskCep.mask($('input.mask-cep'))
    }

}